import PrinPage from "./PrintPage";

export default PrinPage;
